export default __webpack_public_path__ + "static/media/fauna-mobile-wireframes.36901b7e.png";